import { PreloadedQuery } from "react-relay";

import type { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
// @ts-ignore
import { LoomPricingPage as LoomPricingPageTemplate } from "@/templates/software/loom/pricing/loom-pricing-page.template.tsx";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/product-catalog";

export interface LoomPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
}

export const LoomPricingPage = (props: LoomPricingPageProps) => {
    const { pricingContent, queryRef } = props;

    return (
        <PricingContentContextProviderRelay
            productId="loom"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <LoomPricingPageTemplate />
        </PricingContentContextProviderRelay>
    );
};
